// Mengeneinheiten-Klassifizierung.
// Stück-/Gebinde-Einheiten (STK, PCE, SET, PAK, ...) erlauben KEINE Kommastellen;
// Maß-/Gewichts-/Zeit-Einheiten (KG, L, M, STD, LE, ...) erlauben Kommastellen.
//
// Hinweis: Diese Liste muss mit backend/utils/units.js synchron gehalten werden.

// Normalisierte, großgeschriebene Codes der ganzzahligen Einheiten.
const INTEGER_UNITS = new Set([
  'ST', 'STK', 'STÜCK', 'STUECK', 'STUCK',          // Stück
  'PCE', 'PC', 'PCS', 'PIECE', 'EA', 'EACH',        // Piece / Each
  'SET', 'PAK', 'PK', 'PACK', 'PACKUNG',            // Set / Packung
  'KAR', 'KARTON', 'CT', 'BX', 'BOX',               // Karton / Box
  'PAR', 'PAA', 'PAIR',                             // Paar
  'ROL', 'ROLLE', 'ROLL',                           // Rolle
  'DZ', 'DOZ', 'DOZEN',                             // Dutzend
]);

const normalizeUnit = (unit) => {
  if (unit === undefined || unit === null) return '';
  return String(unit).trim().toUpperCase();
};

// true, wenn die Einheit nur ganze Zahlen erlaubt (z. B. STK, PCE, SET, PAK).
export const isIntegerUnit = (unit) => INTEGER_UNITS.has(normalizeUnit(unit));

// Schrittweite für <input type="number"> abhängig von der Einheit.
export const quantityStep = (unit) => (isIntegerUnit(unit) ? '1' : '0.01');

// Bereinigt einen Mengen-Eingabewert: bei ganzzahligen Einheiten auf Ganzzahl runden.
// Dezimale Einheiten werden UNVERÄNDERT durchgereicht — sonst würde beim Tippen von
// "2," der Wert sofort zu 2 und die Nachkommastelle ginge verloren.
// Leere/ungültige Eingaben bleiben ebenfalls unverändert.
export const sanitizeQuantity = (value, unit) => {
  if (value === '' || value === null || value === undefined) return value;
  if (!isIntegerUnit(unit)) return value;
  const num = parseFloat(value);
  if (Number.isNaN(num)) return value;
  return Math.round(num);
};

// Formatiert eine Menge für die Anzeige: ganzzahlige Einheiten ohne Nachkommastellen,
// dezimale Einheiten ohne überflüssige Nullen (2.50 -> 2.5, 3.00 -> 3).
export const formatQuantity = (value, unit) => {
  const num = parseFloat(value);
  if (Number.isNaN(num)) return value ?? '';
  if (isIntegerUnit(unit)) return String(Math.round(num));
  return String(parseFloat(num.toFixed(3)));
};
